import { EnrolledSessionsInterface, EnrollmentInterface } from '@app/interfaces/_index';

import { Enrollment } from '../models/enrollment.model';
import { Adapter } from './adapter';
import { EnrolledSessionsAdapter } from './enrolled-sessions.adapter';

/**
 * Adapt raw Docebo enrollment object to Enrollment model
 * NOTE: The item fields are the default json property names.
 */
export class EnrollmentAdapter implements Adapter<Enrollment> {
  private enrolledSessionsAdapter: EnrolledSessionsAdapter;

  constructor() {
    this.enrolledSessionsAdapter = new EnrolledSessionsAdapter();
  }

  /**
   * Adapt data item into a Enrollment model.
   * @param item - data item Enrollment Interface to be transformed
   * @returns - returns an adapted Enrollment model
   */
  adapt(item: EnrollmentInterface): Enrollment {
    let enrollment: Enrollment;

    if (item) {
      enrollment = new Enrollment(
        item.id,
        item.name,
        item.url,
        item.total_time,
        item.duration,
        item.complete_percent,
        item.status,
        item.can_enter,
        item.session_date_begin,
        item.type,
        item.location_name,
        item.enroll_end_date,
        item.enrolled_sessions
          ? item.enrolled_sessions.map((field: EnrolledSessionsInterface) =>
              this.enrolledSessionsAdapter.adapt(field)
            )
          : []
      );
    }
    return enrollment;
  }
}
